import { getOpenAIInstance } from '../openai';

export async function analyzeSalaryTrends(payrollData: any[]) {
  const openai = await getOpenAIInstance();

  const completion = await openai.chat.completions.create({
    messages: [
      {
        role: 'system',
        content:
          'Analyze payroll data to identify salary trends, overtime patterns, and compensation insights. Provide recommendations for optimizing payroll costs while maintaining employee satisfaction.',
      },
      {
        role: 'user',
        content: `Analyze these payroll records and provide insights: ${JSON.stringify(payrollData)}`,
      },
    ],
    model: 'gpt-4-turbo-preview',
  });

  return completion.choices[0].message.content;
}

export async function generatePayslipSummary(payslipData: any) {
  const openai = await getOpenAIInstance();

  const completion = await openai.chat.completions.create({
    messages: [
      {
        role: 'system',
        content:
          'Generate a clear, detailed summary of a payslip including base pay, overtime, deductions, and benefits. Highlight any notable changes from previous periods.',
      },
      {
        role: 'user',
        content: `Generate a summary for this payslip: ${JSON.stringify(payslipData)}`,
      },
    ],
    model: 'gpt-4-turbo-preview',
  });

  return completion.choices[0].message.content;
}

export async function calculateTaxDeductions(employeeData: any) {
  const openai = await getOpenAIInstance();

  const completion = await openai.chat.completions.create({
    messages: [
      {
        role: 'system',
        content:
          'Calculate tax deductions and benefits based on employee data, tax brackets, and applicable regulations. Provide a breakdown of calculations and explanations.',
      },
      {
        role: 'user',
        content: `Calculate deductions for this employee: ${JSON.stringify(employeeData)}`,
      },
    ],
    model: 'gpt-4-turbo-preview',
    response_format: { type: 'json_object' },
  });

  return JSON.parse(completion.choices[0].message.content);
}

export async function suggestBenefitsOptimization(employeeData: any) {
  const openai = await getOpenAIInstance();

  const completion = await openai.chat.completions.create({
    messages: [
      {
        role: 'system',
        content:
          'Analyze employee benefits and suggest optimizations to maximize value while controlling costs. Consider tax implications and employee preferences.',
      },
      {
        role: 'user',
        content: `Suggest benefits optimizations for: ${JSON.stringify(employeeData)}`,
      },
    ],
    model: 'gpt-4-turbo-preview',
  });

  return completion.choices[0].message.content;
}
